import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import './PageLayout.scss'
// import SideBar from './../sideBar/SideBar'
import SideBar from "./../ReusableComponents/SideBar";

const PageLayout = (props) => {

  const sessionTimeOut = useSelector((state) => state.user.sessionTimeOut);

  const history = useNavigate();
  useEffect(() => {
    if (sessionTimeOut) {
      history('/login');
    }
  }, [props.children]);

  useEffect(() => {
    if (sessionTimeOut) {
      history('/login');
    }
  },[sessionTimeOut]);  

  return (
    <>
      <SideBar headerTitle={props.headerName}>
          {props.children}
      </SideBar>
      {/*<div className="PageLayout-main">
        <div className="headerPL-con">
          <Header name={props.headerName}/>
          <Headermobile name={props.headerName}/>
        </div>
        <div className="PageLayout-container">
          <div className="PageLayout-L">
            <SideBar />
          </div>
        </div>
    </div>*/}
    </>
  );
};

export default PageLayout;
